import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import SiteHeader from "../components/SiteHeader";
import { ArrowRight } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await register(email, password, name);
      toast.success("Account created");
      navigate("/app");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <SiteHeader />
      <main className="max-w-md mx-auto px-6 py-20">
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Create your account</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mt-2">Get started</h1>
        <p className="text-zinc-600 mt-2 text-sm">Free forever for individual verifications.</p>

        <form onSubmit={submit} className="mt-8 space-y-5 border border-zinc-200 bg-white rounded-sm p-6">
          <div className="space-y-1.5">
            <Label htmlFor="name" className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Name</Label>
            <Input id="name" required value={name} onChange={(e) => setName(e.target.value)}
                   className="rounded-sm h-10" data-testid="register-name-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email" className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   className="rounded-sm h-10" data-testid="register-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password" className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Password (6+ chars)</Label>
            <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                   className="rounded-sm h-10" data-testid="register-password-input" />
          </div>
          {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-sm px-3 py-2" data-testid="register-error">{error}</div>}
          <Button type="submit" disabled={loading} className="w-full bg-[#0F172A] hover:bg-[#0F172A]/90 rounded-sm h-10" data-testid="register-submit-btn">
            {loading ? "Creating…" : (<>Create account <ArrowRight className="w-4 h-4" /></>)}
          </Button>
        </form>

        <div className="mt-6 text-sm text-zinc-600">
          Already have an account?{" "}
          <Link to="/login" className="text-[#0F172A] underline underline-offset-4" data-testid="register-to-login-link">
            Sign in
          </Link>
        </div>
      </main>
    </div>
  );
}
